import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';
import { POST_URL } from '@utils/api/endpoints.ts';
import { useMutation, useQueryClient } from 'react-query';

export interface DocumentPayload {
  document_type: 'document' | 'caption';
  filename: string;
  folder_id?: string | null;
  document_id?: string;
  max_line_length?: number;
  max_line_words?: number;
  max_segment_duration?: number;
  max_segment_lines?: number;
  max_segment_words?: number;
  max_silence_between_words?: number;
  min_segment_gap?: number;
  webhook_headers?: string[];
  webhook_method?: 'POST' | 'PUT';
  webhook_url?: string | null;
}

async function postDocument(
  sessionId: string,
  payload: DocumentPayload
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<BaseResponse<any>> {
  const url = `${POST_URL(sessionId).copyDocument}`;
  const { data } = await Axios.post(url, payload);
  return data;
}

export function useCopyDocument() {
  const queryClient = useQueryClient();

  return useMutation<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BaseResponse<any>,
    AxiosError<BaseError>,
    { sessionId: string; payload: DocumentPayload }
  >(async ({ sessionId, payload }) => postDocument(sessionId, payload), {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['folders'],
        exact: false
      });
    },
    useErrorBoundary: false
  });
}
